import { createSlice } from '@reduxjs/toolkit';
import { sendDraftDistributionApi } from '../../../rtk-apis/hl7/sendDraftDistribution';

const initialState = {
  status: '',
  result: null as any,
  msg: '',
  loading: false,
};

const sendDraftDistributionSlice = createSlice({
  name: 'sendDraftDistribution',
  initialState,
  reducers: {
    clearState: state => {
      state.status = '';
      state.result = null;
      state.msg = '';
      state.loading = false;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(sendDraftDistributionApi.pending, state => {
        state.loading = true;
      })
      .addCase(sendDraftDistributionApi.fulfilled, (state, action) => {
        state.loading = false;
        state.status = 'SUCCESS';
        state.result = action.payload;
        state.msg = action.payload?.msg || 'Sent successfully';
      })
      .addCase(sendDraftDistributionApi.rejected, (state, action) => {
        state.loading = false;
        state.status = 'FAILED';
        state.msg = (action.payload as string) || 'Send failed';
      });
  },
});

export const { clearState: clearSendDraftDistributionState } = sendDraftDistributionSlice.actions;
export default sendDraftDistributionSlice.reducer;
